import { IsNotEmpty, IsNumber, IsDefined, Validate, Equals, IsEmail } from 'class-validator';
import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class RoleDataService extends DataService<typeof Model.Core.Logic.ViewModels.Security.RoleItem, Model.Core.Logic.ViewModels.Security.RoleItem, RoleItem> {
	protected map(entity: Model.Core.Logic.ViewModels.Security.RoleItem): RoleItem {
		return new RoleItemModel(entity);
	}

	public static make(context?: any): RoleDataService {
		return new RoleDataService(context, ctx => ctx.Roles);
	}

	public add() {
		const entity = new Model.Core.Logic.ViewModels.Security.RoleItem();
		entity.isRole = true;
		(entity as any).dynamicProperties = {
			permissions: [],
		};
		return entity;
	}
}

export class RoleItemModel extends EntityModel<Model.Core.Logic.ViewModels.Security.RoleItem, RoleItem> implements RoleItem {
	@property<RoleItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<RoleItemModel>(o => o.entity.userName, (o, value) => o.entity.userName = value)
	@IsDefined({
		message: 'username is empty'
	})
	public userName: string;

	@property<RoleItemModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	@IsDefined({
		message: 'display name is empty'
	})
	public displayName: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: {};

	@property<RoleItemModel>(o => o.entity.isRole, (o, value) => o.entity.isRole = value)
	public isRole: boolean;

	@property<RoleItemModel>(o => o.entity.isAdmin, (o, value) => o.entity.isAdmin = value)
	public isAdmin: boolean;
}



// WEBPACK FOOTER //
// ./src/app/general/roles/form/role-form.data.ts